import { Box, Button, Grid } from '@mui/material';
import { IComponentCss, PeriodSelectType } from '@tap/mui-ui';
import AverageAgeChart from './AverageAgeChart';
import AverageAgeTable from './AverageAgeTable';
import { IssueAverageAgeReportResult } from '@tap/data-providers';

/* Таблица Средний возраст
*/

// Стили
const css: IComponentCss = {
    contentWrap: {
        position: 'relative',
        display: 'inline-grid',
        width: '100%',
    },
    optionsButton: {
        marginBottom: '5px',
        float: 'right',
    },
    chartWrap: {
        width: '90%',
        marginBottom: '40px',
    },
};

type AverageAgeReportProps = {
    periodType: PeriodSelectType,
    reportData: IssueAverageAgeReportResult[],
    onOptionsButtonClick: () => void,
};

export default function AverageAgeReport({ periodType, reportData, onOptionsButtonClick }: AverageAgeReportProps) {

    return (
        <>
            <Box sx={css.contentWrap}>
                <Grid>
                    <Button
                        size='small'
                        sx={css.optionsButton}
                        onClick={onOptionsButtonClick}
                    >
                        Параметры отчёта
                    </Button>
                </Grid>
                <Grid sx={css.chartWrap}>
                    <AverageAgeChart
                        reportData={reportData}
                        periodType={periodType}
                    />
                </Grid>
                <AverageAgeTable reportData={reportData} />
            </Box>
        </>
    );
}

